import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import auth from "./modules/auth/index";
import users from "./modules/users/index";
import locations from "./modules/locations/index";
import orders from "./modules/orders/index";
import payments from "./modules/payments/index";
import calculator from "./modules/calculator/index";
import notice from "./modules/notice/index";
import config from "./modules/config/index";
import popup from "./modules/popup/index";
import account from "./modules/account/index";
import form from "./modules/form/index";

Vue.use(Vuex);

const subscriber = (store) => {
  store.subscribe((mutation, state) => {
    localStorage.setItem("vuex3", JSON.stringify(state));
  });
};
const store = new Vuex.Store({
  namespaced: true,
  state: {
    tokenPayload: {}, // 재확인
    placedOrder: [],
    completeOrder: [],
    noticeModalVisible7: true,
    noticeModalVisible8: true,
    noticeModalVisible9: true,
    noticeModalVisible10: true,
    urgentWeatherModal: true,
    popupPayload: {},
  },
  getters,
  actions,
  mutations,
  modules: {
    auth,
    calculator,
    locations,
    orders,
    users,
    payments,
    notice,
    config,
    popup,
    account,
    form,
  },
  plugins: [subscriber],
});

export default store;
